import { render, staticRenderFns } from "./private_lesson_coach_header.vue?vue&type=template&id=56801f04&"
import script from "./private_lesson_coach_header.vue?vue&type=script&lang=js&"
export * from "./private_lesson_coach_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports